import { memo } from 'react';

import styles from '../FileIconChat.styles.m.css';

export const FileIconHover = memo(() => {
  return (
    <>
      <circle
        className={styles.primaryColor}
        cx="39"
        cy="39"
        r="9"
      />
      <path
        className={styles.secondaryColor}
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.4257 43.7623C38.571 43.9089 38.7746 44 38.9999 44C39.015 44 39.03 43.9996 39.0449 43.9988C39.1175 43.9948 39.1875 43.9814 39.2536 43.9598C39.3677 43.9226 39.4749 43.8596 39.5657 43.7708L42.7657 40.6403C43.0781 40.3347 43.0781 39.8392 42.7657 39.5336C42.4533 39.2279 41.9467 39.2279 41.6343 39.5336L39.7999 41.3281V35.7826C39.7999 35.3504 39.4417 35 38.9999 35C38.558 35 38.1999 35.3504 38.1999 35.7826V41.3279L36.3657 39.5336C36.0533 39.2279 35.5467 39.2279 35.2343 39.5336C34.9219 39.8392 34.9219 40.3347 35.2343 40.6403L38.4257 43.7623Z"
      />
      <path
        className={styles.primaryColor}
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.12 29.8855C43.6921 28.0247 44 26.0483 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44C26.0483 44 28.0247 43.6921 29.8855 43.12C29.3167 41.8637 29 40.4688 29 39C29 33.4772 33.4772 29 39 29C40.4688 29 41.8637 29.3167 43.12 29.8855Z"
      />
      <path
        className={styles.secondaryColor}
        d="M31.5389 19.94C30.8766 18.7823 29.6443 17.6151 28.81 16.9C28.3341 16.4958 27.1146 15.4925 25.88 14.8429V19.63C25.88 19.8 26.02 19.94 26.19 19.94L31.5389 19.94Z"
      />
      <path
        className={styles.secondaryColor}
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.88 14.25H23.21C20.95 14.25 19.3 14.25 18.2 14.41C17.21 14.55 16.42 15.48 16.3 16.66C15.9 20.64 15.9 27.1 16.3 31.07C16.4 32.04 17.04 32.88 17.97 33.26C19.17 33.75 21.41 33.75 24 33.75C27.07 33.75 29.01 33.71 30.06 33.25C30.99 32.84 31.6 32.02 31.7 31.07C31.9477 28.6203 31.9934 24.2177 31.9993 21.94L26.19 21.94C24.91 21.94 23.88 20.9 23.88 19.63V14.25Z"
      />
    </>
  );
});
